var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('span',{staticClass:"text-h6 text-sm-h5"},[_vm._v(" امروز: "+_vm._s(_vm.today)+" ")])}
var staticRenderFns = []

export { render, staticRenderFns }